/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_AciInputs */

const en_cargos_aci = /** @type {(inputs: Cargos_AciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACI`)
};

const es_cargos_aci = /** @type {(inputs: Cargos_AciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACI`)
};

/**
* | output |
* | --- |
* | "ACI" |
*
* @param {Cargos_AciInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_aci = /** @type {((inputs?: Cargos_AciInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_AciInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_aci(inputs)
	return es_cargos_aci(inputs)
});